import { Box } from "@mui/material";
import React, { useState } from "react";
import Createjobdrawer from "../components/createjobdrawer"; // path apne hisaab se adjust karo
import { useNavigate } from "react-router-dom";

const Createjob = () => {
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  const editFlag = queryParams.get("edit");
  const jobId = queryParams.get("JobId");

  // Edit page pe aate hi modal open rahega
  // Close hone par jobOrders pe wapas jaayenge
  const handleClose = () => {
    navigate("/jobOrders?page=1");
  };

  return (
    <Box
      sx={{ backgroundColor: "rgba(242, 248, 255, 1)" }}
      className="pageWrapper"
    >
      <Createjobdrawer
        open={true}
        onClose={handleClose}
        editFlag={editFlag}
        jobId={jobId}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        setIsSuccess={setIsSuccess}
      />
    </Box>
  );
};

export default Createjob;
